import { render, staticRenderFns } from "./Detail.vue?vue&type=template&id=2567c5fe&scoped=true"
import script from "./Detail.vue?vue&type=script&lang=js"
export * from "./Detail.vue?vue&type=script&lang=js"
import style0 from "./Detail.vue?vue&type=style&index=0&id=2567c5fe&prod&lang=scss"
import style1 from "./Detail.vue?vue&type=style&index=1&id=2567c5fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2567c5fe",
  null
  
)

export default component.exports